//404에러시 보여줄 컴포넌트
function ErrorComponent(){
    return(
        <div className="ErrorComponent">
            <h1>잘못된 접근입니다 - 라우팅 문제_404 Error</h1>
        </div>
    )
}

export default ErrorComponent